import { observable, computed, action, IObservableArray } from "mobx";

import { AppStore, AreaStore } from "./AppStore";
import * as MetaManagement from "../MetaManagement";
import { AreaUiInfoImpl } from "../States/AreaUiInfo";
import { DialogStore } from "../Stores/DialogStore";
import { Strings } from "../Stores/StringsStore";
import { UiRepos } from "../Stores/UiStore";

export class MetaDataStore extends AreaStore {

	@observable searchTerm: string = "";
	@observable model: MetaManagement.MetaInfo[] = [];
	@observable hash: string;
	@observable moveMode = false;
	@observable metaValuesMoveMode = false;
	moveFrom: number = -1;
	searchTimeoutHandle: number;
	areaUiInfo: AreaUiInfoImpl = new AreaUiInfoImpl(UiRepos.META_UI_INFO);

	search(){
		this.isBusy = this.searchTerm == "";
		MetaManagement.queryMetasAsync(this.searchTerm).then(model => {
			this.model = model;
			this.hash = JSON.stringify(this.model);
			this.isBusy = false;
		}).catch(error => {
			DialogStore.showError(Strings.general.errorDialogTitle, error);
		});
	}

	loadUiSettings (){
		this.areaUiInfo.asideWidth = UiRepos.metaUiInfo.asideWidth;
		this.areaUiInfo.isCollapsed = UiRepos.metaUiInfo.isCollapsed;
		this.areaUiInfo.contentGroupAccordionStatus.replace(UiRepos.metaUiInfo.contentGroupAccordionStatus);
	}


}